import React from 'react'
import t from '~t'
import { API_ENDPOINT_URL } from '~data/constants/app'
import config from '~config'

import { Button, Layout, Label, ButtonRow, HeaderTitle as Title, Header, Icon } from '~ui';

export default function AccountElectron() {
    return (
        <>
            <Header data-no-shadow style={{minHeight: 0}}>
                <Title>{t.s('welcome')} Save</Title>
            </Header>

            <Layout>
                <Label>{t.s('raindropTagline')}</Label>
                <div />

                <ButtonRow>
                    <Button
                        href={config.links.home}
                        variant='outline'>
                        {t.s('about')}…
                    </Button>

                    <Button
                        href={`${API_ENDPOINT_URL}auth/jwt?done_uri=rnio://account/jwt`}
                        target='_blank'
                        variant='primary'>
                        <Icon name='open' size='micro' />
                        {t.s('signIn')}
                    </Button>
                </ButtonRow>
            </Layout>
        </>
    )
}